import Vue from "vue";
//to ensure the text wont break styling in foreign languages
Vue.filter("format_date", value => {
  if (value != null) {
    let date = null;
    if (typeof value == "string") {
      date = new Date(value);
    }
    return date.toLocaleDateString();
    // return (
    //   (date.getMonth() + 1 > 9 ? "" : "0") +
    //   (date.getMonth() + 1) +
    //   "/" +
    //   (date.getDate() > 9 ? "" : "0") +
    //   date.getDate() +
    //   "/" +
    //   date.getFullYear()
    // );
  }
});
